"use strict";

export const settings = {
    DEF_LENGTH: 3,
    options: {message: 'Invalid CSC', level: "ERROR"}
};

function cvcValidator(value, cvcLength) {
    if (!value) return true;
    const digits = (value || '').replace(/\D+?/g, '');
    return digits.length === cvcLength;
}

export default function validate$cvc(options) {
    const opts = options ? {
        ...settings.options,
        ...options
    } : settings.options;

    return function validate$cvc$return(value, vm) {
        const cvcLength = vm.path(opts.length || 'cardData.cvcLength') || settings.DEF_LENGTH;
        if (cvcValidator(value, cvcLength)) {
            return null;
        }
        return {
            type: 'ERROR',
            level: opts.level,
            message: opts.message
        }
    };
}



/** WEBPACK FOOTER **
 ** ./src/types/card/cvcValidator.js
 **/